import React, {useEffect} from 'react'
import ModalEmitir from '../../../../../components/Modals/ModalsFacturacion/ModalEmitir'
import ModalResumenFacturaEmitida from './CREModalResumenFacturaEmitida'
import ModalImprimirFactura from '../../../../../components/Modals/ModalsFacturacion/ModalImprimirFactura'
import ModalEnviarEmail from '../../../../../components/Modals/ModalsFacturacion/ModalEnviarEmail'
import {State} from '../../../../../reducers'
import {useDispatch, useSelector} from 'react-redux'
import {bindActionCreators} from 'redux'
import { actionComprobanteRetencionEmision, actionsOperaciones, } from '../../../../../actions/action-creators'
import {OPSendEmail} from '../../../../../interfaces/operaciones.interface'
import {emailInvoice} from '../../../../../utils/invoice/validateSendInvoice'
import {generalOpenModalMessage} from '../../../../../actions/general.actions'
import {useHistory} from 'react-router'
import {anularFactura} from '../../../../../actions/operaciones/operaciones.actions'
import { comprobanteRetencionClearAll } from '../../../../../actions/comprobante-retencion/comprobanteRetencionEmision.actions'
import { convertDateFormatAnular } from '../../../../../utils/stringDate'
import ModalAnularFactura3 from '../../../../../components/Modals/ModalsFacturacion/ModalAnularFactura3'
import { docsDatosReceptorReset } from '../../../../../actions/documentos/documentos.actions'
import { unirChipsArray, unirChipsReturnFirst } from '../../../../../utils/strings.utils'

const CREModalsResumenControl = () => {
  const {modals, datosFacturaRes, datosEmisor, formCliente, formSucursal, anulado, } = useSelector((state: State) => state.comprobanteRetencion)
  const {resultAnulaciones} = useSelector((state: State) => state.historial)
  const loader = useSelector((state: State) => state.general.loader)
  const dispatch = useDispatch()
  const actionsFE = bindActionCreators(actionComprobanteRetencionEmision, dispatch)
  const {sendTransactionEmail} = bindActionCreators(actionsOperaciones, dispatch)
  const history = useHistory()
  const {datos} = useSelector((state: State) => state.userLogin)

  useEffect(() => {
    if (resultAnulaciones.length > 0) actionsFE.comprobanteRetencionVerificarAnulacion(funcionRedirigir)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resultAnulaciones])
  
  const funcionRedirigir = () => {
    dispatch(comprobanteRetencionClearAll())
    dispatch(docsDatosReceptorReset())
    history.push('/otros-documentos/comprobante-retencion/formulario')
  }

  const handleEnviarEmail = async (formEnvio: emailInvoice) => {
    if (loader) return
    const sendEmail: OPSendEmail = {
      Correo: formEnvio.email.trim(),
      Documento: datosFacturaRes?.JsonFactura,
      Sello: datosFacturaRes?.Sello,
      json: datosFacturaRes?.JsonFacturaFile || "",
      idSucursal: datos?.sucursal_seleccionada,
      idEmpresa: `${datos?.codigo_empresa}`
    }

    if (await sendTransactionEmail(sendEmail)) {
      dispatch(generalOpenModalMessage(`Enviar por email`, `El correo fue enviado exitosamente.`))
      actionsFE.comprobanteRetencionOpenCloseModalEmail(false)
    }
  }

  const handleClicEmitir = () => actionsFE.comprobanteRetencionClicEmitirModal(history)

  const handleAnular = async () => {
    if (anulado) return
    const anularDoc: any = {
      documento: datosFacturaRes.JsonFactura,
      sellorecibido: datosFacturaRes.Sello,
      DetallesDTE: {
        receptor: getReceptor(),
        emisor: getEmisor(),
        resumen: {totalIva: "0"},
        identificacion: {
          tipoDte: "07",
          codigoGeneracion: datosFacturaRes.codigoGeneracion,
          numeroControl: `DTE-07-${formSucursal.datosSerie.serie}-${formSucursal.datosSerie.numeroactual}`,
          fecEmi: convertDateFormatAnular(datosFacturaRes.fhProcesamiento.split(' ')[0]),
        },
      },
    }
    dispatch(anularFactura([anularDoc]))
  }

  const getReceptor = () => {
    return {
      numDocumento: formCliente.numId ? formCliente.tipoDocumento === "13" ? formCliente.numId : formCliente.numId?.trim().replace(/-/g, '') : null,
      tipoDocumento: formCliente.tipoDocumento ? formCliente.tipoDocumento === "sinDocumento" ? null : formCliente.tipoDocumento : null,
      nrc: null,
      nombre: formCliente.nombre ? formCliente.nombre?.trim() : null,
      telefono: formCliente.telefono ? formCliente.telefono?.trim() : null,
      correo: unirChipsReturnFirst(formCliente.chipsEmail!, formCliente.email!) ?? null,
    }
  }
  const getEmisor = () => {
    return {
      nombre: datosEmisor.nombre,
      nit: datosEmisor.nit,
      nrc: datosEmisor.nrc,
      telefono: datosEmisor.telefono,
      correo: datosEmisor.correo,
      tipoEstablecimiento: datosEmisor.tipoestablecimiento,
    }
  }

  return (
    <>
      {modals.activeEmitirFactura && (<ModalEmitir Styles={{width:"70%", maxWidth: "450px"}} title="Emitir comprobante de retención" detail="Estás a punto de emitir este comprobante de retención ¿deseas continuar?" ClicCancelar={actionsFE.comprobanteRetencionCloseModalEmitir} ClicEmitir={handleClicEmitir} />)}
      {modals.activeFacturaEmitida && <ModalResumenFacturaEmitida />}
      {modals.activeImpresion && (<ModalImprimirFactura documento={datosFacturaRes?.JsonFactura} sello={datosFacturaRes?.Sello} modoTicket={modals.modoTicketPrint} onCancel={() => actionsFE.comprobanteRetencionOpenCloseModalImprimir(false)} onPrint={() => actionsFE.comprobanteRetencionOpenCloseModalImprimir(false)} />)}
      {modals.activeEmail && ( <ModalEnviarEmail defaultEmail={''} chipsEmail={unirChipsArray(formCliente.chipsEmail!, formCliente.email!)} showBackBtn={true} onBackBtn={() => actionsFE.comprobanteRetencionOpenCloseModalEmail(false)} onSendEmail={handleEnviarEmail} /> )}
      {modals.activeAnular && (<ModalAnularFactura3 closeModalEliminar={() => actionsFE.comprobanteRetencionOpenCloseModalAnular(false)} actionEliminar={handleAnular} detail={`DTE-07-${formSucursal.datosSerie.serie}-${formSucursal.datosSerie.numeroactual}`} descripcion="Nota: ten en cuenta que no podrás visualizar el comprobante, porque estará anulado y te redirigirá a realizar un nuevo comprobante." />
      )}
    </>
  )
}

export default CREModalsResumenControl
